<template>
  <div>
    
    <!-- Badges -->
    <div class="badges">
      <div class="container">
        <div class="row">
          <div class="col-lg-6">
            <div class="badge-quality" :style="'background:'+row.bgColor9">
              <div class="q-badge-view">
              <img v-if="row.image9" :src="row.image9" class="" :alt="row.title9" /></div>
              <div class="q-badge-details">
                <div class="bg-title white-color mb-2"
                    v-html="row.title9"
                    :style="'color:'+row.color9+' !important'">
                </div>
                <div class="text white-color mb-3"
                    v-html="row.subTitle9"
                    :style="'color:'+row.subTitleColor9+' !important'">
                </div>
                <router-link v-if="row.button9" :to="row.redirect9" class="btn btn-corner">
                  <div>
                    {{ row.button9 }} <span class="icon-arrow-right ic"></span>
                  </div>
                </router-link>
              </div>
            </div>
          </div>

          <div class="col-lg-6">
            <div class="badge-news" :style="'background:'+row.bgColor10+''">
              <div class="n-badge-view">
              </div>
              <div class="n-badge-details">
                <div class="bg-title mb-3" 
                    v-html="row.title10"
                    :style="'color:'+row.color10+' !important'">
                </div>
                <div class="newsletter mb-2 d-flex justify-content-between">
                  <input v-model="email" type="text" class="news-input" :placeholder="row.subTitle10"/>
                  <button @click="newsletter" class="subscribe-btn d-flex align-items-center">
                        {{ row.button10 }} <span class="icon-arrow-right ic"></span>
                  </button>
                </div>
                <div v-if="success" style="color: #080" class="alert-msg">email sent successfully.</div>
                <div v-if="error" style="color: #f00" class="alert-msg">this email not valid.</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Badges -->

  </div>
</template>


<style scoped>
.alert-msg {
  padding: 10px 0;
  font-size: 17px;
}
</style>

<script>
import axios from 'axios';
export default {
  name: "Section5",
  props: ['row'],
  components: {},
  data() {
    return {
      pgLoading: true,
      email: "",
      success: false,
      error: false,
    };
  },
  created() {
      //
  },
  methods: {
    newsletter() {
      const options = {
        url: window.baseURL + '/newsletters',
        method: "POST",
        data: {
          email: this.email
        },
      };

      axios(options)
        .then((res) => {
          console.log(res);
          this.email = "";
          this.success = true;
          this.error = false;
        })
        .catch((err) => {
          console.log(err.message);
          this.success = false;
          this.error = true;
        });
    }
  },
};
</script>
